import React from 'react';
import { Row, Col, Card } from 'antd';
import { ReactComponent as Logo } from '../../images/logo-securiti-stacked.svg';
import { ReactComponent as IconAssetWithErrorOutlie } from '../../images/icon-asset-with-error-outline.svg';
import { useTranslation } from '../../i18n/useTranslation';

export const UnauthorisedPage = () => {
    const { t } = useTranslation();
    return (
        <div className="c-unauthorized-page fill-height">
            <Row justify="center" className="fill-height">
                <Col lg={12} sm={16} xs={24}>
                    <div className="text-center mb-4">
                        <Logo role="img" aria-label="Securiti Logo" className="brand-logo" />
                    </div>
                    <Card className="f-card text-center px-4 py-2">
                        <IconAssetWithErrorOutlie
                            role="img"
                            aria-label="Access Denied"
                            className="f-size-icon-lg f-color-securiti-orange-s100"
                        />
                        <div className="f-text-title f-text-semibold f-text-single-line f-color-dark-black-s100 py-1 mt-2">
                            {t('Access Denied')}
                        </div>
                        <div className="f-text-medium-content f-color-dark-black-s100 px-4">
                            {t('UNAUTHORISED_PAGE_DESC')}
                        </div>
                    </Card>
                </Col>
            </Row>
            <div className="text-center py-4 px-2">
                <div className="f-text-medium-content f-color-dark-black-s70">
                    &copy; {new Date().getFullYear()} {t('Securiti')}. {t('All rights reserved')}
                </div>
            </div>
        </div>
    );
};
